import { useTranslation } from 'react-i18next';
import { IpponErrorArea } from '@ippon-ui/react';

export const LoadingErrorComponent = ({
  error,
  dataSelector,
}: {
  error: Error;
  dataSelector: string;
}) => {
  const { t } = useTranslation('loader');

  return (
    <IpponErrorArea
      title={t('loader.error.title')}
      description={t('loader.error.description')}
      detailLabel={t('loader.error.detail')}
      detailMessage={error}
      dataSelector={dataSelector}
    />
  );
};
